import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ChangeGochiKidDonateFlagGroupDialog from '../molecules/ChangeGochiKidDonateFlagGroupDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(withState('openChange', 'updateOpenChange', false));

const button = enhance(
  ({
    groupId,
    openChange,
    disabled,
    updateOpenChange,
    textButton,
    gochiKidDonateFlag,
    handleChangePageAction
  }) => {
    const updateChange = () => {
      updateOpenChange(true);
    };
    return (
      <div>
        <Button
          disabled={disabled}
          color="primary"
          onClick={() => updateChange(true)}
        >
          {textButton}
        </Button>
        <ChangeGochiKidDonateFlagGroupDialog
          openChange={openChange}
          updateOpenChange={updateOpenChange}
          target="Change"
          groupId={groupId}
          oldGochiKidDonateFlag={gochiKidDonateFlag}
          handleChangePageAction={handleChangePageAction}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
